// client/src/components/TiptapEditor/extensions/FontSize.js
import { Mark } from "@tiptap/core";

export const FontSize = Mark.create({
  name: "fontSize",

  addOptions() {
    return {
      types: ["textStyle"],
    };
  },

  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          fontSize: {
            default: null,
            parseHTML: (element) => element.style.fontSize,
            renderHTML: (attributes) => {
              if (!attributes.fontSize) {
                return {};
              }
              return {
                style: `font-size: ${attributes.fontSize}`,
              };
            },
          },
        },
      },
    ];
  },

  addCommands() {
    return {
      setFontSize:
        (size) =>
        ({ chain }) => {
          return chain().setMark("textStyle", { fontSize: size }).run();
        },
      // Este es el comando corregido, que no causa conflictos.
      unsetFontSize:
        () =>
        ({ chain }) => {
          return chain().setMark("textStyle", { fontSize: null }).run();
        },
    };
  },

  // Esta es la "receta" que faltaba o no se registraba correctamente.
  // Le dice a Tiptap que esta marca se debe renderizar como una etiqueta <span>.
  renderHTML({ HTMLAttributes }) {
    return ["span", HTMLAttributes, 0];
  },

  parseHTML() {
    return [
      {
        tag: "span",
        getAttrs: (element) => {
          if (typeof element === "string") return false;
          // Si el span tiene un estilo de font-size, lo reconocemos como nuestra marca.
          return element.style.fontSize ? {} : false;
        },
      },
    ];
  },
});
